/* ============================================================
 * Diagnóstico M.E.N.T.E.™ — The Mente Digital
 * Puerto vanilla-JS de la app Next.js original: mismo motor de
 * scoring (lib/diagnostico.js) y misma state machine
 * (intro → segmento → quiz → gate → results), sin frameworks.
 *
 * El contenido (preguntas, lecturas, palancas, CTAs, segmentos)
 * llega inyectado por Liquid en snippets/diagnostico-data.liquid,
 * como JSON, no está hardcodeado aquí.
 * ============================================================ */
(function () {
  "use strict";

  var root = document.getElementById("tmd-diagnostico-root");
  if (!root) return;

  var dynamicEl = document.getElementById("tmd-diag-dynamic");
  var gateEl = document.getElementById("tmd-diag-gate");

  // ------------------------------------------------------------
  // Datos (inyectados por Liquid)
  // ------------------------------------------------------------
  var raw = JSON.parse(
    document.getElementById("tmd-diagnostico-data").textContent
  );

  var FASES = raw.fases; // [{id, letra, nombre}]
  var PREGUNTAS = raw.preguntas; // [{id, fase, impacto, texto, opciones, palanca, glosario, varianteEcommerce}]
  var LECTURAS = raw.lecturas; // {faseId: {rojo, amarillo, verde}}
  var LECTURAS_ECOMMERCE = raw.lecturasEcommerce; // {faseId: {rojo, amarillo, verde}}
  var CTA_POR_RANGO = raw.cta; // {rango: {titulo, texto, boton}}
  var SEGMENTOS = raw.segmentos; // [{id, emoji, nombre, descripcion, abierto}]
  var NOTA_GEO = raw.notaGeo;
  var CALENDLY_URL =
    raw.calendlyUrl || root.getAttribute("data-calendly-fallback") || "https://calendly.com/thementedigital";

  var COLOR_RANGO = { verde: "#22C55E", amarillo: "#F5A623", rojo: "#EF4444" };
  var ETIQUETA_RANGO = {
    verde: "Sistema activo",
    amarillo: "Sistema parcial",
    rojo: "Zona ciega",
  };

  var PAISES = [
    { bandera: "🇨🇴", nombre: "Colombia", codigo: "+57" },
    { bandera: "🇲🇽", nombre: "México", codigo: "+52" },
    { bandera: "🇺🇸", nombre: "Estados Unidos", codigo: "+1" },
    { bandera: "🇪🇸", nombre: "España", codigo: "+34" },
    { bandera: "🇦🇷", nombre: "Argentina", codigo: "+54" },
    { bandera: "🇨🇱", nombre: "Chile", codigo: "+56" },
    { bandera: "🇵🇪", nombre: "Perú", codigo: "+51" },
    { bandera: "🇪🇨", nombre: "Ecuador", codigo: "+593" },
    { bandera: "🇵🇦", nombre: "Panamá", codigo: "+507" },
    { bandera: "🇨🇷", nombre: "Costa Rica", codigo: "+506" },
    { bandera: "🇬🇹", nombre: "Guatemala", codigo: "+502" },
    { bandera: "🇩🇴", nombre: "Rep. Dominicana", codigo: "+1809" },
    { bandera: "🇧🇴", nombre: "Bolivia", codigo: "+591" },
    { bandera: "🇵🇾", nombre: "Paraguay", codigo: "+595" },
    { bandera: "🇺🇾", nombre: "Uruguay", codigo: "+598" },
    { bandera: "🇻🇪", nombre: "Venezuela", codigo: "+58" },
    { bandera: "🇧🇷", nombre: "Brasil", codigo: "+55" },
    { bandera: "🇭🇳", nombre: "Honduras", codigo: "+504" },
    { bandera: "🇸🇻", nombre: "El Salvador", codigo: "+503" },
    { bandera: "🇳🇮", nombre: "Nicaragua", codigo: "+505" },
    { bandera: "🇨🇦", nombre: "Canadá", codigo: "+1" },
  ];

  // ------------------------------------------------------------
  // Scoring — puerto literal de lib/diagnostico.js
  // ------------------------------------------------------------
  function preguntasPorFase(faseId) {
    return PREGUNTAS.filter(function (p) {
      return p.fase === faseId;
    });
  }

  function scoreFase(faseId, respuestas) {
    var preguntas = preguntasPorFase(faseId);
    var bruto = 0,
      min = 0,
      max = 0;
    for (var i = 0; i < preguntas.length; i++) {
      var p = preguntas[i];
      var certeza = respuestas[p.id];
      if (!certeza) return null;
      bruto += certeza * p.impacto;
      min += 1 * p.impacto;
      max += 5 * p.impacto;
    }
    return Math.round(((bruto - min) / (max - min)) * 100);
  }

  function scoreTotal(scores) {
    var vals = FASES.map(function (f) {
      return scores[f.id];
    });
    var sum = vals.reduce(function (a, b) {
      return a + b;
    }, 0);
    return Math.round(sum / vals.length);
  }

  function rango(score) {
    if (score >= 60) return "verde";
    if (score >= 30) return "amarillo";
    return "rojo";
  }

  function palancaPrioritaria(respuestas) {
    var candidatas = PREGUNTAS.filter(function (p) {
      return respuestas[p.id] < 5;
    });
    if (candidatas.length === 0) return null;
    candidatas.sort(function (a, b) {
      return (
        respuestas[a.id] - respuestas[b.id] || b.impacto - a.impacto
      );
    });
    var p = candidatas[0];
    var fase = FASES.filter(function (f) {
      return f.id === p.fase;
    })[0];
    return { pregunta: p, fase: fase };
  }

  // ------------------------------------------------------------
  // Helpers de segmento — resuelven override de ecommerce si existe
  // ------------------------------------------------------------
  function textoPregunta(p, segmento) {
    if (segmento === "ecommerce" && p.varianteEcommerce && p.varianteEcommerce.texto) {
      return p.varianteEcommerce.texto;
    }
    return p.texto;
  }

  function opcionesPregunta(p, segmento) {
    if (segmento === "ecommerce" && p.varianteEcommerce && p.varianteEcommerce.opciones) {
      return p.varianteEcommerce.opciones;
    }
    return p.opciones;
  }

  function glosarioPregunta(p, segmento) {
    if (
      segmento === "ecommerce" &&
      p.varianteEcommerce &&
      p.varianteEcommerce.glosario &&
      p.varianteEcommerce.glosario.length
    ) {
      return p.varianteEcommerce.glosario;
    }
    return p.glosario;
  }

  function lecturaFase(faseId, rg, segmento) {
    if (
      segmento === "ecommerce" &&
      LECTURAS_ECOMMERCE[faseId] &&
      LECTURAS_ECOMMERCE[faseId][rg]
    ) {
      return LECTURAS_ECOMMERCE[faseId][rg];
    }
    return LECTURAS[faseId][rg];
  }

  function textoPalanca(pregunta, segmento) {
    if (
      segmento === "ecommerce" &&
      pregunta.varianteEcommerce &&
      pregunta.varianteEcommerce.palanca
    ) {
      return pregunta.varianteEcommerce.palanca;
    }
    return pregunta.palanca;
  }

  // ------------------------------------------------------------
  // Utilidades de render
  // ------------------------------------------------------------
  function esc(str) {
    var div = document.createElement("div");
    div.textContent = str == null ? "" : String(str);
    return div.innerHTML;
  }

  function el(html) {
    var tpl = document.createElement("template");
    tpl.innerHTML = html.trim();
    return tpl.content.firstElementChild;
  }

  function mostrarDynamic(node) {
    gateEl.hidden = true;
    dynamicEl.hidden = false;
    dynamicEl.innerHTML = "";
    dynamicEl.appendChild(node);
  }

  // ------------------------------------------------------------
  // Estado
  // ------------------------------------------------------------
  var state = {
    paso: "intro", // intro | segmento | quiz | gate | results
    segmento: null,
    segmentoDetalle: "",
    respuestas: {},
    scores: null,
    total: null,
    quizIdx: 0,
  };

  // ------------------------------------------------------------
  // Persistencia en sessionStorage
  // ------------------------------------------------------------
  // Necesaria porque el gate se envía con un submit NATIVO del navegador
  // (Shopify rechaza con 400 cualquier POST a {% form 'customer' %} hecho
  // vía fetch()/AJAX — solo acepta navegación real de formulario). Un
  // submit real implica recarga completa de página, así que sin esto se
  // perdería todo el estado (respuestas, scores) calculado en memoria.
  // También protege contra un refresh accidental a mitad del quiz.
  var STORAGE_KEY = "tmd-diagnostico-state";

  function guardarEstado() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      // Storage lleno/deshabilitado: degradamos sin romper el flujo.
    }
  }

  function restaurarEstado() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function limpiarEstadoGuardado() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      // no-op
    }
  }

  function ir(paso) {
    state.paso = paso;
    guardarEstado();
    render();
  }

  function render() {
    if (state.paso === "intro") return renderIntro();
    if (state.paso === "segmento") return renderSegmento();
    if (state.paso === "quiz") return renderQuiz();
    if (state.paso === "gate") return renderGate();
    if (state.paso === "results") return renderResults();
  }

  // ------------------------------------------------------------
  // Paso: Intro
  // ------------------------------------------------------------
  function renderIntro() {
    var fasesHtml = FASES.map(function (f) {
      return (
        '<div class="tmd-diag-intro__fase">' +
        '<div class="tmd-diag-intro__fase-letra">' + esc(f.letra) + "</div>" +
        '<div class="tmd-diag-intro__fase-nombre">' + esc(f.nombre) + "</div>" +
        "</div>"
      );
    }).join("");

    var node = el(
      '<section class="tmd-diag-intro">' +
        '<p class="tmd-diag__eyebrow">The Mente Digital</p>' +
        '<h1 class="tmd-diag-intro__title">Diagnóstico <span style="color:var(--tmd-purple)">M.E.N.T.E.</span><sup style="font-size:1rem">™</sup></h1>' +
        '<p class="tmd-diag-intro__lead">En 5 minutos vas a saber en cuál de las 5 fases de tu sistema de marketing se está perdiendo el capital — y qué hacer al respecto.</p>' +
        '<div class="tmd-diag-intro__fases">' + fasesHtml + "</div>" +
        '<ul class="tmd-diag-intro__list">' +
        "<li>· 15 preguntas, 3 por fase. Sin respuestas correctas: responde como opera tu negocio hoy.</li>" +
        "<li>· Recibes un score por fase (0–100), un semáforo y nuestra lectura estratégica.</li>" +
        "<li>· Metodología: Certeza × Impacto, la misma que usamos con nuestros clientes.</li>" +
        "</ul>" +
        '<button type="button" class="button" id="tmd-diag-start">Empezar diagnóstico</button>' +
        "</section>"
    );

    node.querySelector("#tmd-diag-start").addEventListener("click", function () {
      // Reinicio limpio: por si queda un diagnóstico previo guardado.
      limpiarEstadoGuardado();
      ir("segmento");
    });

    mostrarDynamic(node);
  }

  // ------------------------------------------------------------
  // Paso: Segmento
  // ------------------------------------------------------------
  function renderSegmento() {
    var node = el(
      '<section class="tmd-diag-segmento">' +
        '<p class="tmd-diag__eyebrow">Antes de empezar</p>' +
        '<h2>¿Cuál describe mejor tu negocio?</h2>' +
        '<p class="tmd-diag-intro__lead">El diagnóstico adapta sus preguntas a tu tipo de operación. Elige la opción que más se parezca a cómo vendes hoy.</p>' +
        '<div class="tmd-diag-segmento__grid" id="tmd-diag-segmento-grid"></div>' +
        "</section>"
    );

    var grid = node.querySelector("#tmd-diag-segmento-grid");
    var otroAbierto = false;

    function pintarGrid() {
      grid.innerHTML = "";
      SEGMENTOS.forEach(function (s) {
        var wrap = document.createElement("div");
        var activa = s.abierto && otroAbierto;

        var card = el(
          '<button type="button" class="tmd-diag-segmento__card">' +
            '<span class="tmd-diag-segmento__emoji">' + esc(s.emoji) + "</span>" +
            "<span>" +
            '<span class="tmd-diag-segmento__nombre">' + esc(s.nombre) + "</span>" +
            '<p class="tmd-diag-segmento__descripcion">' + esc(s.descripcion) + "</p>" +
            "</span>" +
            "</button>"
        );
        if (activa) {
          card.style.borderColor = "var(--tmd-purple)";
          card.style.background = "rgba(139, 92, 246, 0.15)";
        }
        card.addEventListener("click", function () {
          if (s.abierto) {
            otroAbierto = true;
            pintarGrid();
            var input = grid.querySelector("#tmd-diag-segmento-detalle");
            if (input) input.focus();
            return;
          }
          state.segmento = s.id;
          state.segmentoDetalle = "";
          ir("quiz");
        });
        wrap.appendChild(card);

        if (activa) {
          var panel = el(
            '<div class="tmd-diag-segmento__detalle-panel">' +
              '<label class="tmd-diag-field"><span>¿Qué vendes o qué haces?</span>' +
              '<input type="text" id="tmd-diag-segmento-detalle" class="tmd-diag-segmento__detalle" placeholder="Ej: academia de idiomas, restaurante, inmobiliaria…" maxlength="120">' +
              "</label>" +
              '<button type="button" class="tmd-diag-button tmd-diag-button--primary" id="tmd-diag-segmento-continuar" disabled>Continuar</button>' +
              "</div>"
          );
          var input2 = panel.querySelector("#tmd-diag-segmento-detalle");
          var btn2 = panel.querySelector("#tmd-diag-segmento-continuar");
          input2.addEventListener("input", function () {
            btn2.disabled = input2.value.trim().length < 3;
          });
          btn2.addEventListener("click", function () {
            state.segmento = "otro";
            state.segmentoDetalle = input2.value.trim();
            ir("quiz");
          });
          wrap.appendChild(panel);
        }

        grid.appendChild(wrap);
      });
    }

    pintarGrid();
    mostrarDynamic(node);
  }

  // ------------------------------------------------------------
  // Paso: Quiz
  // ------------------------------------------------------------
  function renderQuiz() {
    var idx = state.quizIdx;
    var pregunta = PREGUNTAS[idx];
    var fase = FASES.filter(function (f) {
      return f.id === pregunta.fase;
    })[0];
    var progreso = Math.round((idx / PREGUNTAS.length) * 100);
    var seleccion = state.respuestas[pregunta.id];
    var glosario = glosarioPregunta(pregunta, state.segmento);

    var glosarioHtml = "";
    if (glosario && glosario.length) {
      var resumen =
        glosario.length === 1
          ? "¿Qué es " + esc(glosario[0].t) + "?"
          : "¿Qué significan estos términos?";
      var dl = glosario
        .map(function (g) {
          return (
            "<div><dt>" + esc(g.t) + ": </dt><dd>" + esc(g.d) + "</dd></div>"
          );
        })
        .join("");
      glosarioHtml =
        '<details class="tmd-diag-quiz__glosario"><summary>' +
        resumen +
        "</summary><dl>" +
        dl +
        "</dl></details>";
    }

    var opcionesHtml = opcionesPregunta(pregunta, state.segmento)
      .map(function (op) {
        var activa = seleccion === op.certeza;
        return (
          '<button type="button" class="tmd-diag-quiz__option' +
          (activa ? " tmd-diag-quiz__option--active" : "") +
          '" data-certeza="' +
          op.certeza +
          '">' +
          esc(op.texto) +
          "</button>"
        );
      })
      .join("");

    var node = el(
      '<section class="tmd-diag-quiz">' +
        '<div class="tmd-diag-quiz__progress">' +
        '<div class="tmd-diag-quiz__progress-row"><strong>Fase: ' +
        esc(fase.nombre) +
        "</strong><span>" +
        (idx + 1) +
        " / " +
        PREGUNTAS.length +
        "</span></div>" +
        '<div class="tmd-diag-quiz__progress-track"><div class="tmd-diag-quiz__progress-fill" style="width:' +
        progreso +
        '%"></div></div>' +
        "</div>" +
        '<h2 class="tmd-diag-quiz__question">' +
        esc(textoPregunta(pregunta, state.segmento)) +
        "</h2>" +
        glosarioHtml +
        '<div class="tmd-diag-quiz__options">' +
        opcionesHtml +
        "</div>" +
        '<button type="button" class="tmd-diag-quiz__back" id="tmd-diag-quiz-back"' +
        (idx === 0 ? " disabled" : "") +
        ">← Volver a la pregunta anterior</button>" +
        "</section>"
    );

    node.querySelectorAll(".tmd-diag-quiz__option").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var certeza = Number(btn.getAttribute("data-certeza"));
        state.respuestas[pregunta.id] = certeza;
        setTimeout(function () {
          if (idx < PREGUNTAS.length - 1) {
            state.quizIdx = idx + 1;
            ir("quiz");
          } else {
            terminarQuiz();
          }
        }, 250);
        // Repinta de inmediato para mostrar la selección antes del avance
        renderQuiz();
      });
    });

    node.querySelector("#tmd-diag-quiz-back").addEventListener("click", function () {
      if (idx > 0) {
        state.quizIdx = idx - 1;
        ir("quiz");
      }
    });

    mostrarDynamic(node);
  }

  function terminarQuiz() {
    var scores = {};
    FASES.forEach(function (f) {
      scores[f.id] = scoreFase(f.id, state.respuestas);
    });
    state.scores = scores;
    state.total = scoreTotal(scores);
    ir("gate");
  }

  // ------------------------------------------------------------
  // Paso: Gate (captura de lead) — el form real vive en el Liquid,
  // solo lo mostramos/ocultamos y lo cableamos una vez.
  // ------------------------------------------------------------
  var gateWired = false;

  function renderGate() {
    dynamicEl.hidden = true;
    gateEl.hidden = false;
    if (!gateWired) {
      wireGateForm();
      gateWired = true;
    }
    if (state.gateError) {
      var errorBox = document.getElementById("tmd-diag-form-error");
      errorBox.textContent = state.gateError;
      errorBox.hidden = false;
      state.gateError = null;
    }
  }

  function wireGateForm() {
    var selectIndicativo = document.getElementById("tmd-diag-indicativo");
    selectIndicativo.innerHTML = PAISES.map(function (p) {
      var sel = p.codigo === "+57" ? " selected" : "";
      return (
        '<option value="' + p.codigo + '"' + sel + ">" + p.bandera + " " + p.codigo + "</option>"
      );
    }).join("");

    var form = document.getElementById("tmd-diag-lead-form");
    var errorBox = document.getElementById("tmd-diag-form-error");
    var submitBtn = document.getElementById("tmd-diag-submit");

    form.addEventListener("submit", function (evt) {
      // No interceptamos con fetch(): Shopify responde 400 a peticiones
      // POST a {% form 'customer' %} que no sean una navegación real de
      // formulario. Dejamos el submit nativo — Shopify redirige de vuelta
      // a return_to (esta misma página) tanto en éxito como en error.
      if (!prepararEnvioLead(form, errorBox, submitBtn)) {
        evt.preventDefault();
      }
      // Si es válido, guardamos el estado y dejamos pasar el submit.
    });
  }

  function validoGate() {
    var nombre = document.getElementById("tmd-diag-nombre").value.trim();
    var email = document.getElementById("tmd-diag-email").value.trim();
    var whatsapp = document.getElementById("tmd-diag-whatsapp").value;
    var autoriza = document.getElementById("tmd-diag-autoriza").checked;
    var digitos = whatsapp.replace(/\D/g, "");
    return (
      nombre.length >= 2 &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&
      digitos.length >= 7 &&
      autoriza
    );
  }

  function nombreSegmentoLegible() {
    if (state.segmento === "ecommerce") return "Ecommerce";
    if (state.segmento === "b2b") return "B2B / Servicios";
    return "Otro: " + (state.segmentoDetalle || "sin detalle");
  }

  // Rellena los campos ocultos del form y persiste el estado antes del
  // submit nativo. Devuelve true si el form es válido y se puede enviar
  // (dejando pasar el submit), false si hay que bloquearlo.
  function prepararEnvioLead(form, errorBox, submitBtn) {
    errorBox.hidden = true;

    if (!validoGate()) {
      errorBox.textContent =
        "Revisa tus datos: nombre, email, WhatsApp y la autorización son obligatorios.";
      errorBox.hidden = false;
      return false;
    }

    var nombre = document.getElementById("tmd-diag-nombre").value.trim();
    var indicativo = document.getElementById("tmd-diag-indicativo").value;
    var whatsapp = document.getElementById("tmd-diag-whatsapp").value.trim();
    var web = document.getElementById("tmd-diag-web").value.trim();
    var whatsappCompleto = indicativo + " " + whatsapp;

    var partes = nombre.split(/\s+/);
    document.getElementById("tmd-diag-first-name").value = partes[0] || nombre;
    document.getElementById("tmd-diag-last-name").value =
      partes.length > 1 ? partes.slice(1).join(" ") : "";
    document.getElementById("tmd-diag-phone").value = whatsappCompleto;

    var rg = rango(state.total);
    document.getElementById("tmd-diag-tags").value = [
      "diagnostico",
      "segmento-" + state.segmento,
      "semaforo-" + rg,
    ].join(", ");

    var fecha = new Date().toLocaleString("es-CO", { timeZone: "America/Bogota" });
    var notaLineas = [
      "Diagnóstico M.E.N.T.E.™ — " + fecha,
      "Segmento: " + nombreSegmentoLegible(),
      "WhatsApp: " + whatsappCompleto,
      "Web: " + (web || "—"),
      "Score total: " + state.total + " (" + ETIQUETA_RANGO[rg] + ")",
    ];
    FASES.forEach(function (f) {
      var s = state.scores[f.id];
      notaLineas.push(
        "  " + f.nombre + ": " + s + " (" + ETIQUETA_RANGO[rango(s)] + ")"
      );
    });
    document.getElementById("tmd-diag-note").value = notaLineas.join("\n");

    // Shopify redirige tras el submit a return_to (éxito o error) en vez
    // de a /contact — el <form> que genera Liquid no conserva por su
    // cuenta el query string actual, así que lo reconstruimos a mano.
    // Esto preserva ?view=diagnostico&preview_theme_id=... mientras se
    // prueba con el tema de desarrollo (necesario hasta que la Página
    // tenga page.diagnostico como plantilla real, algo que solo se puede
    // hacer una vez el tema esté publicado). En producción, sin esos
    // parámetros, el resultado es idéntico a solo el pathname.
    var returnToInput = document.getElementById("tmd-diag-return-to");
    if (returnToInput) {
      returnToInput.value = window.location.pathname + window.location.search;
    }

    // El estado ya tiene scores/respuestas calculados (terminarQuiz() se
    // llamó antes de llegar aquí) — lo persistimos para reconstruir la
    // pantalla de resultados tras la recarga que provoca el submit nativo.
    guardarEstado();

    submitBtn.disabled = true;
    submitBtn.textContent = "Enviando…";
    return true;
  }

  // ------------------------------------------------------------
  // Paso: Results
  // ------------------------------------------------------------
  function radarSvg(scores, size) {
    size = size || 320;
    var cx = size / 2,
      cy = size / 2;
    var r = size / 2 - 44;
    var n = FASES.length;

    function angulo(i) {
      return (Math.PI * 2 * i) / n - Math.PI / 2;
    }
    function punto(i, valor) {
      var rad = (r * valor) / 100;
      return [cx + rad * Math.cos(angulo(i)), cy + rad * Math.sin(angulo(i))];
    }
    function poligono(valor) {
      return FASES.map(function (_, i) {
        return punto(i, valor)
          .map(function (v) {
            return v.toFixed(1);
          })
          .join(",");
      }).join(" ");
    }

    var datos = FASES.map(function (f, i) {
      return punto(i, scores[f.id]);
    });
    var datosStr = datos
      .map(function (p) {
        return p.map(function (v) {
          return v.toFixed(1);
        }).join(",");
      })
      .join(" ");

    var anillos = [25, 50, 75, 100]
      .map(function (v) {
        return (
          '<polygon points="' + poligono(v) + '" fill="none" stroke="#d4d4d4" stroke-width="1"/>'
        );
      })
      .join("");

    var ejes = FASES.map(function (f, i) {
      var p = punto(i, 100);
      return (
        '<line x1="' + cx + '" y1="' + cy + '" x2="' + p[0] + '" y2="' + p[1] + '" stroke="#d4d4d4" stroke-width="1"/>'
      );
    }).join("");

    var puntos = datos
      .map(function (p) {
        return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="4" fill="#F5A623"/>';
      })
      .join("");

    var etiquetas = FASES.map(function (f, i) {
      var p = punto(i, 112);
      var dx = Math.cos(angulo(i));
      // Ancla invertida a propósito: el texto crece hacia el centro (no hacia
      // afuera) para que quepa dentro del viewBox incluso en los ejes cercanos
      // al borde izquierdo/derecho (evita cortar la primera letra).
      var anchor = dx > 0.25 ? "end" : dx < -0.25 ? "start" : "middle";
      return (
        '<text x="' + p[0] + '" y="' + p[1] + '" text-anchor="' + anchor + '" dominant-baseline="middle" fill="#525252" font-size="11" style="font-family:var(--heading-font-family, \'Urbanist\', sans-serif);text-transform:uppercase;letter-spacing:0.08em">' +
        esc(f.nombre) +
        "</text>"
      );
    }).join("");

    return (
      '<svg viewBox="0 0 ' + size + " " + size + '" role="img" aria-label="Radar de scores por fase del Sistema MENTE">' +
      anillos +
      ejes +
      '<polygon points="' + datosStr + '" fill="#8B5CF6" fill-opacity="0.25" stroke="#8B5CF6" stroke-width="2.5" stroke-linejoin="round"/>' +
      puntos +
      etiquetas +
      "</svg>"
    );
  }

  function renderResults() {
    var totalRango = rango(state.total);
    var palanca = palancaPrioritaria(state.respuestas);
    var cta = CTA_POR_RANGO[totalRango];
    var mostrarNotaGeo = state.respuestas[11] <= 2;

    var palancaHtml;
    if (palanca) {
      palancaHtml =
        '<div class="tmd-diag-results__palanca">' +
        '<div class="tmd-diag-results__palanca-eyebrow">Tu palanca #1 · Fase ' +
        esc(palanca.fase.nombre) +
        "</div>" +
        '<p class="tmd-diag-results__palanca-title">' +
        esc(textoPalanca(palanca.pregunta, state.segmento)) +
        "</p>" +
        '<p class="tmd-diag-results__palanca-body">De todo lo que arrojó tu diagnóstico, esta es la intervención con mayor retorno por esfuerzo hoy. Por aquí empezaríamos nosotros.</p>' +
        "</div>";
    } else {
      palancaHtml =
        '<div class="tmd-diag-results__palanca">' +
        '<div class="tmd-diag-results__palanca-eyebrow">Sistema completo</div>' +
        '<p class="tmd-diag-results__palanca-title">Confirmamos que las 15 palancas del sistema están documentadas y activas. Estás en el 1% del mercado.</p>' +
        "</div>";
    }

    var fasesHtml = FASES.map(function (f) {
      var s = state.scores[f.id];
      var rg = rango(s);
      var geoNota =
        f.id === "trafico" && mostrarNotaGeo
          ? '<p class="tmd-diag-results__geo-note">' + esc(NOTA_GEO) + "</p>"
          : "";
      return (
        '<article class="tmd-diag-results__fase">' +
        '<div class="tmd-diag-results__fase-header">' +
        '<h3 class="tmd-diag-results__fase-nombre"><em>' +
        esc(f.letra) +
        "</em> · " +
        esc(f.nombre) +
        "</h3>" +
        '<div class="tmd-diag-results__fase-score">' +
        '<span class="tmd-diag-results__fase-dot" style="background:' +
        COLOR_RANGO[rg] +
        '"></span>' +
        '<span class="tmd-diag-results__fase-numero" style="color:' +
        COLOR_RANGO[rg] +
        '">' +
        s +
        "</span>" +
        "</div></div>" +
        '<div class="tmd-diag-results__fase-bar-track"><div class="tmd-diag-results__fase-bar-fill" style="width:' +
        s +
        "%;background:" +
        COLOR_RANGO[rg] +
        '"></div></div>' +
        '<p class="tmd-diag-results__fase-lectura">' +
        esc(lecturaFase(f.id, rg, state.segmento)) +
        "</p>" +
        geoNota +
        "</article>"
      );
    }).join("");

    var node = el(
      '<section class="tmd-diag-results">' +
        '<p class="tmd-diag__eyebrow">Tu resultado</p>' +
        '<h2>Radar M.E.N.T.E.™ de tu negocio</h2>' +
        '<div class="tmd-diag-results__score">' +
        '<div class="tmd-diag-results__score-number" style="color:' +
        COLOR_RANGO[totalRango] +
        '">' +
        state.total +
        "</div><div>" +
        '<div class="tmd-diag-results__score-label">Score total / 100</div>' +
        '<div class="tmd-diag-results__score-tag" style="color:' +
        COLOR_RANGO[totalRango] +
        '">' +
        esc(ETIQUETA_RANGO[totalRango]) +
        "</div></div></div>" +
        palancaHtml +
        '<div class="tmd-diag-results__radar">' + radarSvg(state.scores) + "</div>" +
        '<div class="tmd-diag-results__fases">' + fasesHtml + "</div>" +
        '<div class="tmd-diag-results__cta">' +
        "<h3 class=\"tmd-diag-results__cta-title\">" + esc(cta.titulo) + "</h3>" +
        '<p class="tmd-diag-results__cta-text">' + esc(cta.texto) + "</p>" +
        '<a class="tmd-diag-button tmd-diag-button--primary" href="' +
        esc(CALENDLY_URL) +
        '" target="_blank" rel="noopener noreferrer">' +
        esc(cta.boton) +
        "</a></div>" +
        '<footer class="tmd-diag__footer">Sistema M.E.N.T.E.™ es metodología propietaria de The Mente Digital · Medellín, Colombia · No dejes tus ventas a la suerte: marketing es ingeniería.</footer>' +
        "</section>"
    );

    mostrarDynamic(node);
  }

  // Pantalla mínima cuando Shopify confirma que el lead se guardó pero no
  // hay estado en sessionStorage para reconstruir el radar (sessionStorage
  // deshabilitado, borrado entre el submit y la recarga, etc.).
  function renderGraciasSinDatos() {
    dynamicEl.hidden = false;
    gateEl.hidden = true;
    var node = el(
      '<section class="tmd-diag-results">' +
        '<p class="tmd-diag__eyebrow">Diagnóstico completado</p>' +
        "<h2>¡Listo! Ya tenemos tus datos.</h2>" +
        '<p class="tmd-diag-intro__lead">Te contactaremos con tu lectura estratégica completa. Si quieres verla ahora mismo, puedes repetir el diagnóstico.</p>' +
        '<button type="button" class="tmd-diag-button tmd-diag-button--primary" id="tmd-diag-restart">Repetir diagnóstico</button>' +
        "</section>"
    );
    node.querySelector("#tmd-diag-restart").addEventListener("click", function () {
      limpiarEstadoGuardado();
      state.paso = "intro";
      render();
    });
    mostrarDynamic(node);
  }

  // Copia al state solo los campos conocidos de un objeto restaurado de
  // sessionStorage (evita pisar funciones/keys inesperadas).
  function restaurarEnState(guardado) {
    if (!guardado) return;
    state.segmento = guardado.segmento || null;
    state.segmentoDetalle = guardado.segmentoDetalle || "";
    state.respuestas = guardado.respuestas || {};
    state.scores = guardado.scores || null;
    state.total = typeof guardado.total === "number" ? guardado.total : null;
    state.quizIdx = guardado.quizIdx || 0;
  }

  // Limpia el fragmento/hash que Shopify agrega a return_to tras el
  // redirect (p.ej. #tmd-diag-lead-form) sin recargar la página.
  function limpiarUrlTrasSubmit() {
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, "", window.location.pathname);
    }
  }

  // ------------------------------------------------------------
  // Arranque
  // ------------------------------------------------------------
  // Shopify redirigió aquí (return_to) tras procesar el submit nativo del
  // gate — el marcador ya viene poblado en el HTML servido por Liquid, sin
  // necesidad de ningún fetch.
  (function arrancar() {
    var statusEl = document.getElementById("tmd-form-status");
    // data-posted (form.posted_successfully?) resultó no ser fiable en esta
    // tienda: en pruebas reales llegó en "false" incluso cuando el Customer
    // SÍ se había creado correctamente en Shopify (con tags y nota
    // completos, verificado en el Admin) — probablemente por cómo esta
    // tienda procesa {% form 'customer' %} con Cuentas de cliente nuevas
    // activas. Por eso ya no lo usamos para decidir éxito.
    //
    // La señal fiable es el hash que Shopify agrega por su cuenta a la URL
    // de return_to (el id del <form>) SOLO cuando el navegador acaba de
    // procesar un submit nativo de ese formulario — nunca aparece en una
    // carga normal de la página. data-has-errors (form.errors) sí es
    // fiable: refleja errores reales de validación de Shopify.
    var conErrores = !!statusEl && statusEl.getAttribute("data-has-errors") === "true";
    var regresoDeSubmit = window.location.hash === "#tmd-diag-lead-form";
    var guardado = restaurarEstado();

    if (regresoDeSubmit && !conErrores) {
      if (guardado && guardado.scores && typeof guardado.total === "number") {
        restaurarEnState(guardado);
        limpiarUrlTrasSubmit();
        ir("results");
        return;
      }
      limpiarUrlTrasSubmit();
      renderGraciasSinDatos();
      return;
    }

    if (conErrores) {
      restaurarEnState(guardado);
      state.gateError =
        "Revisa tus datos: alguno de los campos no pasó la validación de Shopify. Intenta de nuevo.";
      limpiarUrlTrasSubmit();
      ir("gate");
      return;
    }

    // Carga normal: restauramos un quiz a medias si quedó uno por un
    // refresh accidental (pero nunca reabrimos "results"/"gate" sin
    // confirmación real de Shopify — solo progreso de quiz).
    if (guardado && (guardado.paso === "quiz" || guardado.paso === "segmento")) {
      restaurarEnState(guardado);
      state.paso = guardado.paso;
    }
    render();
  })();
})();
